/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { featuresGet } from "../funcs/featuresGet.js";
import { featuresSet } from "../funcs/featuresSet.js";
import { featuresSetRemoteSessionAutoRefreshPolicy } from "../funcs/featuresSetRemoteSessionAutoRefreshPolicy.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ProductFeatures } from "../models/components/productfeatures.js";
import {
  GetProductFeaturesRequest,
  GetProductFeaturesSecurity,
} from "../models/operations/getproductfeatures.js";
import {
  SetProductFeatureRequest,
  SetProductFeatureSecurity,
} from "../models/operations/setproductfeature.js";
import {
  SetRemoteSessionAutoRefreshPolicyRequest,
  SetRemoteSessionAutoRefreshPolicySecurity,
} from "../models/operations/setremotesessionautorefreshpolicy.js";
import { unwrapAsync } from "../types/fp.js";

export class Features extends ClientSDK {
  /**
   * getProductFeatures features
   *
   * @remarks
   * Get the current state of all product feature flags.
   */
  async get(
    request: GetProductFeaturesRequest,
    security?: GetProductFeaturesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ProductFeatures> {
    return unwrapAsync(featuresGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setProductFeature features
   *
   * @remarks
   * Enable or disable an organization feature flag. Staff-managed entitlements (such as sso and scim) additionally require a Speakeasy platform administrator; organization admins can set only the org-settable operational toggles.
   */
  async set(
    request: SetProductFeatureRequest,
    security?: SetProductFeatureSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(featuresSet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setRemoteSessionAutoRefreshPolicy features
   *
   * @remarks
   * Set the organization policy for automatic remote-session refresh.
   */
  async setRemoteSessionAutoRefreshPolicy(
    request: SetRemoteSessionAutoRefreshPolicyRequest,
    security?: SetRemoteSessionAutoRefreshPolicySecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(featuresSetRemoteSessionAutoRefreshPolicy(
      this,
      request,
      security,
      options,
    ));
  }
}
